export { default as QuickAdd } from './quickAdd'
export { default as QuickAddSizes } from './quickAddSizes'



// WEBPACK FOOTER //
// ./src/modules/productTile/quickAdd/index.js